export default class UnactiveAccordion {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    this.group = this.element.querySelector('.acd-group');
    this.des = this.element.querySelector('.acd-des');

    setTimeout(() => {
      this.removeActive();
    }, 1);
  }

  removeActive() {
    this.group.classList.remove('acd-active');
    this.des.style.display = 'none';
  }
}
